import { render, staticRenderFns } from "./paramset.vue?vue&type=template&id=2ec01a00&scoped=true"
import script from "./paramset.vue?vue&type=script&lang=js"
export * from "./paramset.vue?vue&type=script&lang=js"
import style0 from "./paramset.vue?vue&type=style&index=0&id=2ec01a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec01a00",
  null
  
)

export default component.exports